import type { TagFilter } from "./Tag";
import type AgreementPeriod from "./AgreementPeriod";

export interface Filter {
  hideDuplicates: boolean;
  hideDrafts: boolean;
  classifications: string[];
  tags: TagFilter[];
  dateRange: DateRangeFilter;
  currentFolder: string;
  groupByFolders: boolean;
  adviceInstanceId: string;
  evidenceCounts: string[];
  agreementPeriod?: AgreementPeriod;
  summariserStatuses: string[];
}

export interface Sort {
  sortBy: SortBy;
  sortOrder: SortOrder;
}

export enum SortOrder {
  ASC,
  DESC,
}

export enum SortBy {
  FILE_NAME = "displayName",
  DATE_ISSUED = "edxIssueDate",
  CLASSIFICATION = "aiClassification",
  FILE_TYPE = "extension",
  PAGE_COUNT = "edxPageCount",
}

export interface DateRangeFilter {
  from: string;
  to: string;
  includeBlanks: boolean;
}
